import { DatePicker } from "antd";
import dayjs from "dayjs";
import "dayjs/locale/th";
import buddhistEra from "dayjs/plugin/buddhistEra";
import thBEPicker from "../utils/locale/th_BE_picker";

dayjs.locale("th");
dayjs.extend(buddhistEra);

const toThaiDigits = (s) => s.replace(/\d/g, (d) => "๐๑๒๓๔๕๖๗๘๙"[d]);

function formatThaiBE(
  value,
  { thaiDigits = false, longMonth = false, showTime = false } = {},
) {
  if (!value) return "";
  const d = value.locale("th");
  const dd = d.format("DD");
  const month = d.format(longMonth ? "MMMM" : "MMM");
  const yearBE = d.year() + 543;

  let str = `${dd} ${month} ${yearBE}`;

  // เพิ่มเวลา ถ้าเปิด showTime
  if (showTime) {
    const time = d.format("HH:mm");
    str += ` ${time} น.`;
  }

  return thaiDigits ? toThaiDigits(str) : str;
}

export default function ThaiDatePickerTime({
  value,
  onChange,
  thaiDigits = false,
  longMonth = true,
  showTime = false, // ✅ เพิ่ม option แสดงเวลา
  inputReadOnly = true,
  placeholder = "เลือกวันที่ (พ.ศ.)",
  ...props
}) {
  return (
    <DatePicker
      locale={thBEPicker}
      value={value}
      onChange={onChange}
      format={(v) => formatThaiBE(v, { thaiDigits, longMonth, showTime })}
      placeholder={showTime ? "เลือกวันที่และเวลา (พ.ศ.)" : placeholder}
      allowClear
      inputReadOnly={inputReadOnly}
      showTime={showTime ? { format: "HH:mm" } : false} // ✅ เปิด time picker
      {...props}
    />
  );
}

export function ThaiRangePickerTime({
  value,
  onChange,
  thaiDigits = false,
  longMonth = false,
  showTime = false, // ✅ เพิ่ม option แสดงเวลา
  inputReadOnly = true,
  placeholder = ["วันที่เริ่ม (พ.ศ.)", "วันที่สิ้นสุด (พ.ศ.)"],
  ...props
}) {
  const { RangePicker } = DatePicker;

  const timePlaceholder = ["เริ่ม (พ.ศ.)", "สิ้นสุด (พ.ศ.)"];

  return (
    <RangePicker
      locale={thBEPicker}
      value={value}
      onChange={onChange}
      format={(v) => formatThaiBE(v, { thaiDigits, longMonth, showTime })}
      placeholder={showTime ? timePlaceholder : placeholder}
      allowClear
      inputReadOnly={inputReadOnly}
      showTime={showTime ? { format: "HH:mm" } : false} // ✅ เปิด time picker
      {...props}
    />
  );
}
